module.exports = __webpack_public_path__ + "static/img/group-map_202509.9f1bee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group-map_202509.jpg
// module id = qd/r
// module chunks = 99